import { Box } from '@mui/material'

export const compactFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 28,
    fontSize: 13,
    fontFamily: 'Roboto',
  },
  '& .MuiOutlinedInput-input': {
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    boxSizing: 'border-box',
  },
  '& .MuiOutlinedInput-input.MuiSelect-select': {
    paddingRight: '24px',
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiSelect-icon': {
    right: 4,
    fontSize: 18,
  },
} as const

export const materialCategoryFromCrossSection = (cs: CrossSection): MaterialKind =>
  cs.kind === 'Steel' ? 'Steel' : cs.material.kind

export const materialRowKey = (m: Material): string => `${m.kind}__${m.unique_name ?? m.identifier}`

/** Tighter material dropdown: clip label with ellipsis in the closed state. */
export const materialSelectSx = [
  compactFieldSx,
  {
    '& .MuiOutlinedInput-input.MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
] as const

export const cmAdornment = (
  <Box component="span" sx={{ fontSize: 11, color: 'text.secondary' }}>
    cm
  </Box>
)
